var Ranking = function () {

	var comp = $('[data-component="ranking"]'),
			menu,
			table,
			$id;

	this.init = function () {

		this.filter();
		this.select();

		if($(window).width() <= 1024) {
			comp.each(function() {
				menu = $(this).find('[data-component="border-menu"]');
				table = $(this).find('[data-component="ranking-table"]');
				table.each(function() {
					if($(this).data('id') == menu.find('.active').data('id')){
						$(this).show();
					}
				});
			});
		}

	}

	this.filter = function () {

		comp.each(function() {
			menu = $(this).find('[data-component="border-menu"]');
			table = $(this).find('[data-component="ranking-table"]');

			menu.find('a').on('click', function(e) {
				e.preventDefault();

					$id = $(this).data('id');
					menu.find('a').removeClass('active');
					$(this).addClass('active');

					if ($id == 'all') {
						table.fadeIn(300);
					}	else {
						table.each(function() {
							if ($(this).data('id') == $id) {
								$(this).fadeIn(300);
							} else {
								$(this).fadeOut(300);
							}
						});
					}
			});

		});

	}

	this.select = function () {

		comp.find('.select').each(function(){
			$(this).find('span').text($(this).prev('.border').find('.active').text());
		});

		comp.find('.select select').on('change', function() {
			$(this).prev('span').text($(this).find('option:selected').text());

			comp.each(function() {
				menu = $(this).find('[data-component="border-menu"]');
				table = $(this).find('[data-component="ranking-table"]');
				table.hide(200);
				table.each(function() {
					if($(this).data('id') == comp.find('select option:selected').val()){
						$(this).delay(201).show(300);
					}
				});
			});
		});

	}


	return this.init();

}
